import { IShortcutManager } from "./interfaces/IShortcutManager";
import { createShortcutManagerInstance } from "./CreateShortcutManagerInstance.function";

export const shortcutManager: IShortcutManager = createShortcutManagerInstance(document.documentElement);
